define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

// add view security configuration

	var collectionAdminRoles = ['Collection Administrator'];
	var collectionRoles = collectionAdminRoles.concat(['Collection Editor','Collection Viewer']);

	var hierarchyAdminRoles = ['Hierarchy Administrator'];
	var hierarchyEditRoles = hierarchyAdminRoles.concat(['Hierarchy Editor']);
	var hierarchyRoles = hierarchyEditRoles.concat(['Hierarchy Viewer']);

	var materialAdminRoles = ['Material Administrator'];
	var materialEditRoles = materialAdminRoles.concat(['Material Editor']);
	var materialRoles = materialEditRoles.concat(['Material Viewer']);

	var styleAdminRoles = ['Style Administrator'];
	var styleEditRoles = styleAdminRoles.concat(['Style Editor']);
	var styleRoles = styleEditRoles.concat(['Style Viewer']);

	var wbsAdminRoles = ['WBS Admin'];

	csiAccess.addViewRoles({
		"WbsHolder":{
			"Wbs":{
				"":access(full(wbsAdminRoles), readOnly(hierarchyRoles), full(styleRoles), full(materialRoles), full(collectionRoles))
			}
		},
		"WbsReportsHolder":{
			"MilestoneReport":{
				"":access(full(wbsAdminRoles), readOnly(hierarchyRoles), readOnly(styleRoles), readOnly(materialRoles), readOnly(collectionRoles))
			}
		}
	});
});